module.exports = __webpack_public_path__ + "static/media/one-drive-icon.99268ac3.svg";